import React, { useState, useEffect } from "react";
import ContactForm from "../components/contactForm/ContactForm";
import TeamMemberCard from "../components/TeamMemberCard"; // Import the new component
import HeroSectionImage from "../assets/trattamenti/spalla.jpg";
import MinimalArrow from "../components/MinimalArrow";

// Import all images
import dennisRomani from "../assets/staff/denis_romani.webp";
import paolo from "../assets/staff/paolo_murgia.webp";
import luca from "../assets/staff/luca_mascia.webp";
import emyBrunello from "../assets/staff/emy_brunello.webp";
import andreaAppierto from "../assets/staff/andrea_appierto.webp";
import alessandraDosso from "../assets/staff/alessandra_dosso.webp";
import MarcoCollarile from "../assets/staff/marco_collarile.webp";
import AnnaMontresor from "../assets/staff/anna_montresor.webp";
import BONINSEGNAFRANCESCO from "../assets/staff/BONINSEGNA_FRANCESCO.webp";
import MARTIN_PEDERIVA from "../assets/staff/MARTIN_PEDERIVA.webp";
import ALESSANDRO_PADOVANI from "../assets/staff/ALESSANDRO_PADOVANI.webp";
import ANNA_FAVALLI from "../assets/staff/anna_favalli.webp";
import FEDERICO_MARCONI from "../assets/staff/Federico_Marconi.webp";
function Team() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Team members data array
  const teamMembers = [
    {
      name: "Dott. Denis Romani",
      title: "Direttore Sanitario e Medico Chirurgo",
      description: "Specialista in Ortopedia e Traumatologia, Chirurgia della Mano e Microchirurgia. Esperienza e particolare focus nella traumatologia sportiva su arto superiore, polso e mano.",
      imageUrl: dennisRomani,
      backgroundColor: "from-mcare/80 to-black/90"
    },
    {
      name: "Paolo Murgia",
      title: "Fisioterapista e osteopata",
      description: "Vanta 10 anni di esperienza sul campo e una formazione continua e costante, sfruttando le sue conoscenze anche in ambito universitario, dove ogni anno è co-relatore di tesi per diversi studenti.",
      imageUrl: paolo,
      backgroundColor: "from-mcare/80 to-black/90"
    },
    {
      name: "Luca Mascia",
      title: "Fisioterapista e Orthopedic manipulative therapist",
      description: "È stato fisioterapista della prima squadra dell'A.C. Chievo Verona in serie A e B. È inoltre Docente a contratto presso l'Università degli studi di Verona, dove insegna chinesiologia, biomeccanica e fisioterapia sportiva.",
      imageUrl: luca,
      backgroundColor: "from-gray-600/80 to-black/90"
    },
    {
      name: "Anna Montresor",
      title: "Fisioterapista",
      description: "Fisioterapista laureata presso l'Università degli Studi di Verona, specializzata in ambito sportivo muscolo-scheletrico. Lavora come fisioterapista per atleti della Nazionale di atletica leggera e ha completato la certificazione in Italian Sports Physical Therapy",
      imageUrl: AnnaMontresor,
      backgroundColor: "from-mcare/80 to-black/90"
    },
    {
      name: "Francesco Boninsegna",
      title: "Fisioterapista",
      description: "Fisioterapista laureato presso l'Università di Verona, ha collaborato con alcune società di calcio dilettantistiche nel veronese. Attualmente sta terminando la formazione in Fisioterapia Sportiva SPTC (Sports Physical Therapy Certification, edizione 2024/2025), riconosciuta dal GIS Sport.",
      imageUrl: BONINSEGNAFRANCESCO,
      backgroundColor: "from-gray-600/80 to-black/90"
    },
    {
      name: "Martin Pederiva",
      title: "Fisioterapista",
      description: "Fisioterapista specializzato in fisioterapia sportiva muscolo-scheletrica, è stato fisioterapista del settore giovanile dell'A.C. Chievo Verona, collaborando anche con la prima squadra. Dal 2020 è fisioterapista della Nazionale Italiana di Nuoto e ha collaborato nel 2021 con le federazioni di nuoto di Svizzera e Liechtenstein. Sta terminando la formazione in Fisioterapia Sportiva SPTC (Sports Physical Therapy Certification, edizione 2024/2025), riconosciuta dal GIS Sport.",
      imageUrl: MARTIN_PEDERIVA,
      backgroundColor: "from-mcare/80 to-black/90"
    },
    {
      name: "Federico Marconi",
      title: "Fisioterapista",
      description: "Fisioterapista laureato presso l’Università di Verona, con una formazione mirata in ambito muscolo-scheletrico e sportivo. Ha frequentato numerosi corsi specialistici e in procinto di iniziare il Master in Fisioterapia Sportiva organizzato da PhisioVit.",
      imageUrl: FEDERICO_MARCONI,
      backgroundColor: "from-mcare/80 to-black/90"
    },
    // {
    //   name: "Filippo Bonazzi",
    //   title: "Fisioterapista",
    //   description: "Fisioterapista (Università di Verona) e osteopata da oltre 15 anni, è specializzato nella riabilitazione dei disturbi muscolo-scheletrici di mano, polso e gomito, e nel confezionamento di splint termoplastici. È socio dell’Associazione Italiana Riabilitazione Mano (AIRM).",
    //   imageUrl: ,
    //   backgroundColor: "from-mcare/80 to-black/90"
    // },
    // {
    //   name: "Dott.ssa Emy Brunello",
    //   title: "Medico Chirurgo, Specialista in Medicina Fisica e Riabilitazione",
    //   description: "È autrice di numerose pubblicazioni nazionali e internazionali e ha insegnato presso la International Osteopathic Academy, con sede a Chiasso. In passato, ha ricoperto il ruolo di primario presso la Clinica Riabilitativa di Mezzaselva (VI) e all'Ospedale Villa Salus di Mestre. Inoltre, è stata docente presso l'Università di Padova.",
    //   imageUrl: emyBrunello,
    //   backgroundColor: "from-gray-600/80 to-black/90"
    // },
    {
      name: "Dott. Marco Collarile",
      title: "Medico Chirurgo specializzato in Ortopedia e Traumatologia",
      description: "Vanta una fellowship di Chirurgia Ortopedica e Medicina Sportiva Sigascot in Germania e Austria e presso il Rush Hospital di Chicago (Stati Uniti). Dal 2014 ad aprile 2018 è stato dirigente medico d'ortopedia all'ospedale Sacro Cuore-Don Calabria di Verona. Da maggio 2018 è dirigente medico di ortopedia presso la Clinica Humanitas Castelli di Bergamo.",
      imageUrl: MarcoCollarile,
      backgroundColor: "from-gray-600/80 to-black/90"
    },
    {
      name: "Dott. Andrea Appierto",
      title: "Psicologo",
      description: "Psicologo, psicologo dello sport e psicoterapeuta in formazione. Parte dello staff medico della Federazione italiana sport invernali. Lavora con professionisti di diverse discipline sportive e con i settori giovanili, supportando il benessere psicologico e la performance sportiva. Docente del master di Psicologia & Coaching nello sport a Padova.",
      imageUrl: andreaAppierto,
      backgroundColor: "from-mcare/80 to-black/90"
    },
    {
      name: "Alessandro Padovani",
      title: "Infermiere",
      description: "Infermiere e operatore di linfodrenaggio metodo Dr. Vodder. Lavora come nurse di anestesia in sala operatoria da più di 9 anni, presso una clinica ortopedica e di chirurgia estetica. Ha conseguito la certificazione in linfodrenaggio manuale dalla Dr. Vodder Academy, per il trattamento di pazienti con edemi post-operatori, linfedemi, sinusiti, edemi agli arti inferiori, lombalgie, ecc.",
      imageUrl: ALESSANDRO_PADOVANI,
      backgroundColor: "from-gray-600/80 to-black/90"
    },
    {
      name: "Alessandra Dosso",
      title: "Segretaria Amministrativa",
      description: "",
      imageUrl: alessandraDosso,
      backgroundColor: "from-mcare/80 to-black/90"
    },
    {
      name: "Anna Favalli",
      title: "Segretaria",
      description: "",
      imageUrl: ANNA_FAVALLI,
      backgroundColor: "from-gray-600/80 to-black/90"
    }
  ];

  return (
    <>
      <MinimalArrow 
        title={'Il nostro team di professionisti'}
        subtitle={"Terapisti qualificati e specialisti al fianco dei tuoi obiettivi di recupero e performance."}
        backgroundImage={HeroSectionImage}
      />

      {/* Team Grid */}
      <div className="bg-black">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {teamMembers.map((member) => (
              <div key={member.id} className="h-auto">
                <TeamMemberCard
                  name={member.name}
                  title={member.title}
                  description={member.description}
                  imageUrl={member.imageUrl}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Contact Form Section */}
      <div className="grid grid-cols-4 gap-0" id="formContatti">
        <div className="col-span-4 flex justify-center items-center py-32 bg-black z-10">
          {/* <div className="w-full absolute z-0" style={{ height: "120%" }}></div> */}
          <div className="w-full lg:w-2/6 px-5">
            <p className="text-center text-4xl font-semibold text-mcare panoragraf-light">
              Prenota una visita
            </p>
            <ContactForm
              LandingName="mcare"
              Name={true}
              NameClass="text-slate-50"
              NameText="Nome e Cognome:"
              NameRequired={true}
              Tel={true}
              TelClass="text-slate-50"
              TelText="Telefono:"
              TelRequired={true}
              Email={true}
              EmailClass="text-slate-50"
              EmailText="Email:"
              EmailRequired={true}
              ConsensoDati={true}
              ConsensoDatiRequired={true}
              ConsensoDatiText="Consenso dati"
              ConsensoDatiID={1}
              ConsensoDatiClass="text-slate-50"
              successText="Messaggio inviato con successo!"
              successLink="/"
              errorText="Si è verificato un errore, Riprova!"
              SendText="Invia"
              SendClass="progress-button-mcare w-full "
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Team;